import type { App } from 'vue'
import focus from './focus'
import selectOnFocus from './select-on-focus'

export default {
  install (app: App) {
    app.directive('focus', focus)
    app.directive('select-on-focus', selectOnFocus)
  },
}
